import * as Sentry from "@sentry/react";
import { useInsights } from "../../hooks/useInsights";

function AlertasInsightsInner() {
  const userId = (typeof window !== "undefined" && window.__USER_ID__) || "guest";
  const { alerts, loading } = useInsights(userId);

  if (loading || !alerts) {
    return (
      <div className="insights-panel">
        <h2 className="insights-title">Alertas de evolución</h2>
        <p className="insights-subtitle">Cargando datos…</p>
      </div>
    );
  }

  const list = alerts.alerts || [];
  const status = alerts.status || "ok";

  return (
    <div className="insights-panel">
      <h2 className="insights-title">Alertas de evolución</h2>
      <p className="insights-subtitle">
        Cambios importantes detectados en tu actividad.
      </p>

      <div className="insights-card">
        <h3>Estado general</h3>
        <p>
          {status === "ok"
            ? "No se detectaron alertas críticas."
            : `Estado actual: ${status}`}
        </p>
      </div>

      {list.length > 0 ? (
        list.map((a, i) => (
          <div className="insights-card" key={i} style={{ marginTop: "12px" }}>
            <h3>{a.title || `Alerta ${i + 1}`}</h3>
            <p>{a.message || a.description || ""}</p>
          </div>
        ))
      ) : (
        <div className="insights-card" style={{ marginTop: "12px" }}>
          <h3>Seguimiento</h3>
          <p>Se activará automáticamente cuando haya suficiente historial.</p>
        </div>
      )}
    </div>
  );
}

const AlertasInsights = Sentry.withErrorBoundary(AlertasInsightsInner, {
  fallback: (
    <div className="insights-panel" data-testid="alertas-insights-error">
      <h2 className="insights-title">Alertas de evolución</h2>
      <p className="insights-subtitle">
        Ha ocurrido un error al cargar las alertas. El equipo ya fue notificado.
      </p>
    </div>
  ),
});

export default AlertasInsights;
